import { UiButtons } from './buttons';
import { UiComponents } from './components';
import { UiIcons } from './icons';
import { UiImages } from './images';
import { UiText } from './text';

export class UI {
  static icons = {
    HomeIcon: UiIcons.HomeIcon,
    FullScreenIcon: UiIcons.FullScreenIcon,
    CoinIcon: UiIcons.CoinIcon,
    LifeIcon: UiIcons.LifeIcon,
    SoundIcon: UiIcons.SoundIcon,
  };

  static images = {
    Background: UiImages.Background,
    Player: UiImages.Player,
  };

  static buttons = {
    ExitBtn: UiButtons.ExitBtn,
    PlayBtn: UiButtons.PlayBtn,
    ScoreBtn: UiButtons.ScoreBtn,
    ScorePlayBtn: UiButtons.ScorePlayBtn,
    EndGameRestart: UiButtons.EndGameRestart,
    GameOverRestart: UiButtons.GameOverRestart,
    ContinueBtn: UiButtons.ContinueBtn,
  };

  static text = {
    Level: UiText.LevelTxt,
    Lives: UiText.LivesTxt,
    ExitGameText: UiText.ExitGameText,
    GameScore: UiText.GameScore,
    GameOverScore: UiText.GameOverScore,
    HighScores: UiText.HighScores,
    EndGameScore: UiText.EndGameScore,
    GameOver: UiText.GameOver,
    Loading: UiText.Loading,
    PauseGame: UiText.PauseGame,
    WinGameMsg: UiText.WinGameMsg,
  };

  static components = {
    TopPlayers: UiComponents.TopPlayers,
    UpdateTopPlayers: UiComponents.updateTopPlayers,
  };
}
